import Button from '@ui/Button'
import Breadcrumb from '@common/Breadcrumb'
import {ROUTES,SITE } from '@/constants'
import TransformBanner from '@sections/TransformBanner'
import MetaInfo from '@common/MetaInfo'
import { metaTitleFor } from '../assets/js/navBreadcrumb'
const { label, pageDesc, metaDesc } = metaTitleFor(ROUTES.FUNCTIONAL_TESTING)


const TESTING_LIFECYCLE = ['Understand', 'Plan', 'Test', 'Report', 'Retest', 'Validate']
const WHAT_WE_TEST = [
  {title: 'Feature & Requirement Validation',desc:'Verify that every feature performs according to defined business and functional requirements.'},
  {title: 'User Workflows',desc:'Test complete user journeys, business processes, forms, transactions, and critical workflows.'},
  {title: 'Integration & Data Flow', desc:'Validate interactions between application modules, databases, APIs, third-party services, and external systems.'},
  { title: 'Cross-Browser & Device Testing',desc:'Ensure consistent functionality across supported browsers, operating systems, screen sizes, and devices.'},
  { title: 'Regression Testing',desc:'Confirm that new features, fixes, or updates do not affect existing functionality.'},
  { title: 'User Acceptance Support',desc:'Help validate whether the application is ready for business users and production deployment.'},
]

const STACK_BADGES = [ 
  // Middle — 4 badges, 90° apart
  { label: 'Features', tier: 'middle', angle: 0   },
  { label: 'Workflows', tier: 'middle', angle: 70  },
  { label: 'Business rules', tier: 'middle', angle: 140 },
  { label: 'Regression', tier: 'middle', angle: 210 },
  {  label: 'User scenarios', tier: 'middle', angle: 280 },
  ]

// const TIER_SIZE = { inner: '44%', middle: '72%', outer: '100%' }
const TIER_SIZE = {
  inner: '48%',
  middle: '76%',
  outer: '100%',
}
// Inner orbits slowest, outer fastest — matches how real orbital motion looks.
const TIER_DURATION = { inner: 44, middle: 26, outer: 16 } // seconds
export default function FunctionalTesting() {


  return (
    <>  
    {/* <MetaInfo
    title="Functional Testing | CruxBytes"
    description="Ensure your software works as intended with functional testing covering features, workflows, integrations, usability, and business requirements."
    keywords="functional testing, software testing, QA services, regression testing, integration testing, user acceptance testing, cross-browser testing, CruxBytes"
  /> */}
   <MetaInfo
    title={label}
      description={metaDesc}
      keywords=""
      />
      <main id="main-content" className="page-wrapper">
         <div className="page-hero">
           <div className="bg-grid bg-grid--fill" aria-hidden="true" />
           <div className="container">
             {/* <div className="section-label">- Software Testing & QA -</div> */}
             <Breadcrumb />
             <h1 data-aos="fade-up" data-aos-delay={100}>
              {/* Functional Testing */}
              {label}
              </h1>
             <p className="page-subtitle" data-aos="fade-up" data-aos-delay={200}>
             {/* Ensure quality through comprehensive manual and automated software testing. */}
             {pageDesc}
             </p>
             
             <div className="inner-page-actions">
               <Button  href={ROUTES.SALES_ENQUIRY}  variant="primary" icon="fa-arrow-right" iconPos="right" data-aos="fade-up" data-aos-delay={300}>
                 Get a Free Quote
               </Button>

             </div>
           </div>
         </div>
          {/* Section 1 */}
         
                 <section className="section-py bg-linear-gradient-light"  aria-labelledby="on-demand-intro-heading">
                   <div className="container">
                     <div className="section-header pt-4" data-aos="fade-up">                       
                       <p className="text-center">
                         Functional testing validates whether your application behaves according to its defined requirements and delivers the expected experience across different user scenarios
                       </p>
                       <p className="text-center">
                         CruxBytes performs structured functional testing across web applications, mobile apps, enterprise software, and digital platforms to identify functional defects before they affect users. We have an experienced team of professionals who understand the domain as well as the underlying technology. This makes it easier for them to figure out even those bugs which are the rarest of possibilities to occur. We ensure every feature works the way it should.
                       </p>
                       
                     </div>
                   </div>
                 {/* </section>

<section className="section-py bg-peach "> */}
    <div className="container ">
      
       <div className="on-demand-split no-gap">
                  {/* ── LEFT ── */}
         <div className="cp-timeline" data-aos="fade-right" aria-label="Our hiring process">
           <div className="">
           
  <ul className="check-list ps-0">
     <h5>What We Test</h5>
    {WHAT_WE_TEST.map((card, i) => (
      <li
        key={card.title}
        data-aos="fade-up"
        data-aos-delay={(i % 3) * 80}
      >
        {/* <i className="fa-solid fa-circle-check check-list-icon" aria-hidden="true" /> */}
        {/* <i className="fa-regular fa-thumbs-up check-list-icon" aria-hidden="true" /> */}
        <i className="fa-regular fa-star check-list-icon" aria-hidden="true" />
        <div>
          <h6 className="mb-0">{card.title}</h6>
          <p className="wcs-desc">{card.desc}</p>
        </div>
      </li>
    ))}
  </ul>
</div>
              
        </div>
        {/* ── RIGHT:  ── */}
        <div   data-aos="fade-left">  
         <div className="pf-orbit-wrap m-0" data-aos="fade-left">
         
        <div className="stack-orbit" data-aos="fade-left">
          {/* <span className="stack-ring testing-ring stack-ring--1" aria-hidden="true" /> */}
          <span className="stack-ring testing-ring stack-ring--2" aria-hidden="true" />
          <span className="stack-ring  testing-ring stack-ring--3" aria-hidden="true" />
          <span className="stack-testing-center-pill">Does it work?</span>
          {STACK_BADGES.map((badge) => (
            <span
              key={badge.label}
              className="stack-orbit-track"
              style={{
                width: TIER_SIZE[badge.tier],
                height: TIER_SIZE[badge.tier],
                '--start-angle': `${badge.angle}deg`,
                animationDuration: `${TIER_DURATION[badge.tier]}s`,
              }}
            >
              <span className="stack-badge" style={{ animationDuration: `${TIER_DURATION[badge.tier]}s` }}>
                {/* <badge.Icon />  */}
                {badge.label}
              </span>
            </span>
          ))}
        </div>
        </div>
        </div>
      </div>
    </div>
</section>
      {/* Section 3 */}
         <section className="section-py ">
                <div className="container ">
        <div className="on-demand-split">
                  {/* ── LEFT ── */}
         <div className="cp-timeline" data-aos="fade-right" aria-label="Our hiring process">
        
          <div className="cp-timeline-header">
            <h2 >From Requirement to Reliable Release</h2>
            <p >
            Our functional testing process combines test planning, scenario creation, execution, defect tracking, retesting, and regression validation to provide clear visibility into application quality.
            </p>      
                <p>
               Functional testing helps identify issues early, reduce production defects, and ensure that your application delivers the functionality users and businesses expect.
            </p>  
          </div>     
        </div>
                          {/* ── RIGHT:  ── */}
                  <div   data-aos="fade-left">  
                    <div className="contact-form-wrap" style={{backgroundColor:'var(--brand-100)'}}>                      
                      <ol className="step-flow" role="list" aria-label="Testing lifecycle">
                        {TESTING_LIFECYCLE.map((step) => (
                          <li key={step} className="step-flow-item">
                            <span className="step-flow-label" style={{fontSize:'var(--fs-xs)'}}>{step}</span>
                          </li>
                        ))}
                      </ol>
                      
                    </div>
                  </div>

                  </div>
          
       
     
                </div>
                
         </section>
         <TransformBanner />
         </main>
         </>
  )
}